import { get } from '@config'
import React from 'react'
import question_list from './questions'
import './style.css'

export default class Help extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            list: [],
            filteredList: [],
            itemsFirstPage: [],
            itemsSecondPage: [],
        }

    }
    toggleVisible(index) {
        let { list } = this.state
        list = this.state.filteredList.map((item, i) => {
            if (i == index) {
                item.show = !item.show
                return item
            }
            item.show = false
            return item
        })
        this.setState({ filteredList: list })
    }

    onListFix(list) {
        let itemsFirstPage = []
        let itemsSecondPage = []

        if (list.length % 2 === 0) {
            const slice = list.length / 2
            itemsFirstPage = Array(slice).fill(0).map((x, y) => x + y)
            itemsSecondPage = Array(list.length / 2).fill(slice).map((x, y) => x + y)
        } else {
            const slice = parseInt(list.length / 2) + 1
            itemsFirstPage = Array(slice).fill(0).map((x, y) => x + y)
            itemsSecondPage = Array(parseInt(list.length / 2)).fill(slice).map((x, y) => x + y)
        }

        return { itemsFirstPage, itemsSecondPage }
    }

    componentDidMount() {

        let list = question_list.map((item, i) => {
            item.show = false
            return item
        })
        let { itemsFirstPage, itemsSecondPage } = this.onListFix(list)
        this.setState({ filteredList: list, list, itemsFirstPage, itemsSecondPage })
    }

    onChangeInput(e) {
        let filteredList = []
        const { value } = e.target
        if (value === "") {
            filteredList = this.state.list
            let { itemsFirstPage, itemsSecondPage } = this.onListFix(filteredList)
            this.setState({ filteredList, itemsFirstPage, itemsSecondPage })
            return
        }

        const { list } = this.state
        filteredList = list.filter((item) => {

            let titleok = item.title.toLowerCase().includes(value.toLowerCase())
            let descriptionok = item.description.toLowerCase().includes(value.toLowerCase())
            return titleok || descriptionok

        })
        let { itemsFirstPage, itemsSecondPage } = this.onListFix(filteredList)
        this.setState({ filteredList, itemsFirstPage, itemsSecondPage })

    }


    render() {
        return <div className="container-fluid">
            <div className="row">
                <div className="col-12 mb-3">
                    <h1 className="font-weight-bold text-center">
                        Perguntas Frequentes
                    </h1>
                </div>

                <div className='col-lg-5 mx-auto py-2 pb-3'>
                    <div

                        className="input-group">
                        <input onChange={(e) => this.onChangeInput(e)} type="search" className="form-control" placeholder="Procurar">

                        </input>
                        <span className="btn btn-secondary input-group-text border-0">
                            <i className="fas fa-search"></i>
                        </span>
                    </div>
                </div>
            </div>


            <div className="row">
                <div className="col-md-6">
                    <ul className="list-group">
                        {
                            this.state.itemsFirstPage.map((i) => {
                                let item = this.state.filteredList[i]
                                return <li

                                    style={{
                                        cursor: 'pointer',
                                        backgroundColor: '#2f4050'
                                    }}
                                    onClick={() => this.toggleVisible(i)}
                                    className={`list-group-item mb-2 text-white bg-${item.show ? '#2f4050' : "success"} `} key={i}>
                                    <p className="font-weight-bold h6 p-0 m-0">
                                        <i className={`px-2 fas fa-${item.show ? "comments" : "comments"}`}></i> {item.title}
                                    </p>
                                    {item.show ? <p>
                                        <div className='py-3'>
                                            <p>{item.description}</p>

                                            {item.url ? <p className='fas fa-plus'> Para mais detalhes, veja nosso <a
                                                href={item.url}
                                                target='_blank'
                                            >
                                                artigo
                                            </a>
                                            </p> :
                                                <div />}
                                            {item.contact ? <p className='fas fa-plus'>Contate Aqui nosso <a style={{ color: '#04de00', }} target='_blank' href={item.contact}>Suporte Técnico</a></p> : <div />}
                                        </div>
                                    </p> : <div />}
                                </li>
                            })
                        }
                    </ul>
                </div>
                <div className="col-md-6">
                    <ul className="list-group">
                        {
                            this.state.itemsSecondPage.map((i) => {
                                let item = this.state.filteredList[i]
                                return <li
                                    onClick={() => this.toggleVisible(i)}
                                    style={{
                                        cursor: 'pointer',
                                        backgroundColor: '#2f4050'
                                    }}
                                    className={`list-group-item mb-2 text-white bg-${item.show ? "#2f4050" : "success"}`} key={i}>
                                    <p className="font-weight-bold h6 p-0 m-0">
                                        <i className={`px-2 fas fa-${item.show ? "comments" : "comments"}`}></i> {item.title}
                                    </p>
                                    {item.show ? <p>
                                        <div className='py-3'>
                                            <p>{item.description}</p>

                                            {item.url ? <p className='fas fa-plus'> Para mais detalhes, veja nosso <a
                                                href={item.url}
                                                target='_blank'
                                            >
                                                artigo
                                            </a>
                                            </p> :
                                                <div />}
                                            {item.contact ? <p className='fas fa-plus'>Contate Aqui nosso <a style={{ color: '#1ab394', }} target='_blank' href={item.contact}>Suporte Técnico</a></p> : <div />}
                                        </div>
                                    </p> : <div />}
                                </li>
                            })
                        }
                    </ul>
                </div>

                <div
                    style={{
                        overflow: 'hidden',
                        paddingTop: '17.76%',
                        position: 'relative',
                    }}
                >
                    <h3>
                        <b>
                            Videos que podem auxiliar:
                        </b>
                    </h3>
                    <div
                        className='scrollmenu'>
                        <iframe
                            className='d-inline '
                            src="https://www.youtube.com/embed/Tyd2YiJqKD8"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/mQuGmHtLvSk"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/rOnzOC_IW-c"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/nUDDinSVBr4"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/5nF3_1nkC8o"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/8UV6MYnJEts"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/kff9b71o_1g"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/vqFI-9yEjBY"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/-e2DUdzzEtk"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/KTHdFrTi380"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/oFdwWiffRqI"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/iFIVhdJK9j4"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/C-UD6O6GS4A"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/uvADGWKjRjQ"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/tbI-g9aSS-o"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                        <iframe
                            className='d-inline ml-3'
                            src="https://www.youtube.com/embed/NBB62yPlYGo"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        />
                    </div>
                </div>
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/help/index.jsx